import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductExtended } from '../../models';
import { Availability } from '../../models/availability';
import { CustomerProductPrice } from '../../models/price';
import { AuthService } from '../../services/auth/auth.service';
import { GungFlowService } from '../../services/gung-flow/gung-flow.service';
import { LocationConfigService } from '../../services/location-config/location-config.service';
import { MetadataService } from '../../services/metadata/metadata.service';
import { PriceService } from '../../services/price/price.service';
import { GridViewProductCardExtended } from '../concept-detail-product-list-view/concept-detail-product-list-view.component';
import { ProductTreeListViewComponent } from '../product-tree-list-view/product-tree-list-view.component';
import { GungAnonymousConfigService } from '../../services/gung-anonymous-config/gung-anonymous-config.service';

@Component({
    selector: 'lib-product-tree-table-view',
    templateUrl: './product-tree-table-view.component.html',
    styleUrls: ['./product-tree-table-view.component.css'],
    standalone: false
})
export class ProductTreeTableViewComponent extends ProductTreeListViewComponent {
  mappedData: GridViewProductCardExtended[];

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected metadataService: MetadataService,
    protected locationConfigService: LocationConfigService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected gungAnonymousConfigService: GungAnonymousConfigService
  ) {
    super(priceService, gungFlowService, authService, locationConfigService, router, route, gungAnonymousConfigService);
  }

  public trackByFn(index: number) {
    return index;
  }

  protected mapItem(
    id: string,
    product: ProductExtended,
    price: CustomerProductPrice,
    availability: Availability
  ): GridViewProductCardExtended {
    // Product package size
    if (
      product.extra.ar &&
      product.extra.ar.q_jis_fast_pakke_strl &&
      product.extra.ar.artfsgforp &&
      Number(product.extra.ar.artfsgforp) > 1
    ) {
      product.packageSize = Number(product.extra.ar.artfsgforp);
    }
    // Remove dynamic values not visible in list
    const dynamicCollumnsValues = [];
    for (const [index, column] of this.dynamicColumns.entries()) {
      if (column.isDisplayList) {
        dynamicCollumnsValues.push(product.dynamicCollumnsValues?.[index]);
      }
    }
    product = {
      ...product,
      dynamicCollumnsValues
    }
    return {
      product,
      price,
      availability
    };
  }
}
